import * as TablerIcons from '@tabler/icons-react';

/** kebab-case Tabler id → Icon* component */
export function resolveTablerIconComponent(tablerId) {
  if (!tablerId) return null;
  const pascal = String(tablerId)
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('');
  return TablerIcons[`Icon${pascal}`] || null;
}
